export default __webpack_public_path__ + "static/media/icon_guitar.43afda2c.svg";